export default "__VITE_ASSET__37335bfb__"